import {LobbyHeaderTitleDefaultBox} from "./lobby-header-title.default.box";

export const LobbyHeaderTitleBox = LobbyHeaderTitleDefaultBox;